import { Checkbox, Grid } from "@mui/material";
import React from "react";
import { handleChangeHeader } from "../../../../../utils/commonFunctions/fieldCapitalize";
import { pink } from "@mui/material/colors";
import {
	firstFieldAppealsList_v2,
	firstFieldPaidClaimsList_v2,
	secondFieldAppealsList_v2,
	secondFieldPaidClaimsList_v2
} from "../../../../../constants/fieldsList/FieldsList";
import { PaidClaimsSelectColumnHeadersProps } from "../../../../../@types/appealReportAllprops.types";

const PaidClaimsSelectColumnHeaders: React.FC<PaidClaimsSelectColumnHeadersProps> = ({
	key,
	selectedColumns,
	handleUpdateSelectedColumns,
	appealsIDRTrackersCommonUnion,
	handleAppealsIDRTrackersCommonUnionChange
}) => {
	return (
		<div>
			<div
				style={{
					width: "100%",
					margin: "auto",
					textAlign: "center",
					fontWeight: "bolder",
					color: "#ab455c",
					fontSize: "20px",
					marginBottom: "20px"
				}}
			>
				Paid Claims
			</div>
			<div className="fieldContainer">
				<Grid container spacing={4}>
					{[firstFieldPaidClaimsList_v2, secondFieldPaidClaimsList_v2].map((fieldList, columnIndex) => (
						<Grid item xs={12} sm={12} md={6} key={columnIndex}>
							<Grid container style={{ marginBottom: "1rem", color: "#ab455c", fontWeight: "bold" }}>
								<Grid item xs={6}>
									FIELD NAME
								</Grid>
								<Grid item xs={6} style={{ textAlign: "center" }}>
									View
								</Grid>
							</Grid>
							{fieldList.map((field, index) => (
								<Grid container key={index} style={{ marginBottom: "1rem" }} alignItems="center">
									<Grid item xs={6}>
										{handleChangeHeader(field).replace("CHEQUE", "CHECK")}
									</Grid>
									<Grid item xs={6} style={{ textAlign: "center" }}>
										<Checkbox
											checked={selectedColumns.paidclaims[field]}
											sx={{
												color: pink[800],
												"&.Mui-checked": { color: pink[600] }
											}}
											onChange={(event: any) =>
												handleUpdateSelectedColumns(field, event.target.checked, "paidclaims")
											}
										/>
									</Grid>
								</Grid>
							))}
						</Grid>
					))}
				</Grid>
			</div>
		</div>
	);
};

export default PaidClaimsSelectColumnHeaders;
